<template>
	<div class="">
		<!--<div id="header">
			<div class="header-layout">
				<h1 class="logo" id="logo">
					<a>找回密码</a>
					<span class="subtitle">  </span>
				</h1>
				<h2 class="logo-title">  </h2>
				<ul class="header-nav">
					<li class="nav-first"><a href="/register" > 注册 </a></li>
					<li><a href="/login"> 登录 </a></li>
					<li><a href="/webIndex"> 首页 </a></li>

				</ul>

			</div>
		</div>-->

		<div class="zxj_forget">
			<div>
				<div class="slideverify" v-show="isShowSlide">
					<SlideVerify ref="slideblock" @success="sendSmsCode" @close="close_slideverify"></SlideVerify>
				</div>


				<p class="zxj_login__viewP" style="text-align: center;font-size: 21px;margin-bottom: 50px;}">找回密码</p>

				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="width: 400px">


					<el-form-item label="手机号" prop="phone"  >
						<el-input style="width: 300px;" v-model="ruleForm.phone" ></el-input>
					</el-form-item>
					<!--<el-form-item label="手机验证码" prop="phoneCode">
						<el-input style="width: 300px;" v-model="ruleForm.phoneCode"></el-input>
					</el-form-item>-->

					<el-form-item label="手机验证码" prop="phoneCode">
						<div style="display: flex">
							<el-input v-model="ruleForm.phoneCode"
							placeholder="验证码"  show-word-limit class="input_width"

							:readonly='readonly'
							@focus='handlerIptClick'
							autocomplete='off'
							>

							</el-input>
							<el-button v-bind:type="button_sms_type" v-on:click="sendSmsCode2" v-bind:disabled="button_sms_disable" style="margin-left: 5px">{{button_sms_value}}</el-button>
						</div>
					</el-form-item>

					<el-form-item label="密码" prop="password">
						<el-input style="width: 300px;" v-model="ruleForm.password" type="password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="surePassword">
						<el-input style="width: 300px;" v-model="ruleForm.surePassword" type="password"></el-input>
					</el-form-item>
					
					<el-form-item>
						<el-button class="register_btn" @click="submitForm('ruleForm')">确认</el-button>
					</el-form-item>
					
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import {sendSms, forgetPwd} from "../../api/moudles/user";
	import SlideVerify from "./components/SliderVerify";//引入

	export default{

		components: {

			SlideVerify,//注册组件
		},
		data(){
			let checkPwd=((rule,value,callback)=>{
				if(value.trim().length==0){
					callback(new Error("请输入确认密码"));
				}else if(value !=this.ruleForm.password){
					callback(new Error("两次密码不一致"));
				}else{
					callback();
				}
			})

			return{
				isShowSlide:false,
				ruleForm: {
					password: '',
					surePassword: '',
					phone: '',
					phoneCode: '',
				},

				button_sms_type :'success',
				button_sms_value:'发送验证码',
				button_sms_disable:false,
				sms_time_count:120,
				sms_timer:null,
				readonly:true,
				rules: {

					password: [
						{ required: true, message: '请输入密码', transform: value => value, trigger: 'blur' },
						{
							type: 'string',
							message: '请输入不包含空格的字符',
							trigger: 'blur',
							transform(value) {
								if (value && value.indexOf(' ') === -1) {
									return value
								} else {
									return false
								}
							}
						},
						{
							trigger: 'blur',
							validator: (rule, value, callback) => {
								var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/
								if (!passwordreg.test(value)) {
									callback(new Error('密码必须由数字、字母、特殊字符组合,请输入6-16位'))
								}else{
									callback()
								}
							} }
					],

					surePassword: [
						{
							validator: checkPwd,
							required: true,
							trigger: 'blur'
						},
						{
							type: 'string',
							message: '请输入不包含空格的字符',
							trigger: 'blur',
							transform(value) {
								if (value && value.indexOf(' ') === -1) {
									return value
								} else {
									return false
								}
							}
						},
						{
							trigger: 'blur',
							validator: (rule, value, callback) => {
								var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/
								if (!passwordreg.test(value)) {
									callback(new Error('密码必须由数字、字母、特殊字符组合,请输入6-16位'))
								}else{
									callback()
								}
							}
						}
					],


					phone: [{ required: true, message: '手机号不能为空' },
						{ type: 'number',
							message: '手机号格式不正确',
							trigger: 'blur',
							transform(value) {
								var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
								if (!phonereg.test(value)) {
									return false
								} else {
									return Number(value)
								}
							}
						}
					],

					phoneCode: [{
						required: true,
						message: '请输入手机验证码',
						trigger: 'change'
					}],
				}
			}
		},
		methods:{
			handlerIptClick(){
				this.readonly = false;
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {


						let token = localStorage.getItem('userToken')

						let that =  this

						forgetPwd({
							data: {
								token:token,
								form :this.ruleForm
							},
							success: (res) => {

								console.log(res)

								if(res.code == 200){
									this.$message({
										message: '密码修改成功',
										type: 'success'
									});
									setTimeout(function () {

										localStorage.removeItem('userToken')
										localStorage.removeItem('userName')
										localStorage.removeItem('userAvatar')
										//localStorage.clear()
										that.$bus.$emit('brotherEvent', 'login')
										that.$router.push('/login')

									},1000)

									return
								}
								this.$message({
									message: res.msg,
									type: 'error'
								});

							}
						})

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			sendSmsCode2(){

				this.$refs['ruleForm'].validateField('phone', (phoneValid) => {
					if (!phoneValid) {
						setTimeout(() => {

							this.isShowSlide = true;
						}, 500);
					}
				})

			},

			hideSlide() {

				setTimeout(() => {

					this.isShowSlide = false;
				}, 500);
			},

			close_slideverify(){
				this.isShowSlide = false
			},


			sms_count_down(){
				// 验证码倒计时
				if (!this.sms_timer) {
					this.count = this.sms_time_count
					//验证码发送成功，倒计时
					this.button_sms_type = 'info'
					this.button_sms_disable = true
					this.button_sms_value = "已发送(" + this.count + ")"

					//第一种缩写写法
					this.sms_timer = setInterval(() => {
						if (this.count > 0 && this.count <= this.sms_time_count) {
							this.count--

							this.button_sms_value = "已发送(" + this.count + ")"
							console.log(this.count)
						} else {
							clearInterval(this.sms_timer)
							this.sms_timer = null
							console.log('倒计时结束')
							this.button_sms_type = 'success'
							this.button_sms_disable = false
							this.button_sms_value = '发送验证码'

						}
					}, 1000)

				}
			},

			async sendSmsCode() {
				// 手机号为空，警告提示
				if(this.ruleForm.phone === ''){
					this.$message({
						message: '发送手机号不能为空',
						type: 'warning'
					});
					return
				}

				let mobile_mode=/^1[3456789]\d{9}$/;
				if(!mobile_mode.test(this.ruleForm.phone)){
					this.$message({
						message: '手机号码错误',
						type: 'warning'
					});
					return
				}

				// 发送本地springboot请求,本机的地址：192.168.3.12


				await sendSms({
					data: {
						phone: this.ruleForm.phone
					},
					success: (res) => {

						this.isShowSlide = false;

						console.log(res)

						if(res.code == 200){
							this.$message({
								message: '成功发送验证码',
								type: 'success'
							})

							this.sms_count_down()
						}else{
							this.$message.error(res.msg);
						}

					}
				})
			},
		}
	}
</script>

<style scoped>
	.zjxForget {
		min-height: 710px;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.el-form-item__content{
		margin-left: 82px;
	}
	.zxj_forget {

		height: calc(100vh - 160px);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.register_btn {
		width: 300px;
		background-color: #66b1ff;
		color: #fff;
	}

	#header {
		width: 100%;
		height: 100px;
		border-bottom: 1px solid #e3e3e3;
		background-color: #f0f0f0;
	}

	.header-layout {
		width: 990px;
		margin: 0 auto;
		padding: 30px 0;
		overflow: hidden;
	}

	#logo {
		background: url(../../assets/logo.png) 50% no-repeat;
		background-size: 100% 100%;
		margin-top: 8px;
		margin-left: 20px;
		width: 171px;
		height: 48px;
		position: absolute;
		background-position: 0!important;
		top: 15px;
		left: 0;
	}

	#logo a {
		float: left;
		display: inline-block;
		height: 40px;
		width: 178px;
		overflow: hidden;
		text-indent: -999em;
	}

	a:link {
		color: #f40;
	}
	ins, a {
		text-decoration: none;
	}

	.subtitle {
		display: none;
	}


	.header-layout .logo-title {
		float: left;
		display: inline-block;
		width: auto;
		height: 30px;
		padding: 5px 0 0 10px;
		line-height: 30px;
		font-size: 24px;
		color: #303030;
	}

	.header-nav {
		width: auto;
		height: 14px;
		float: right;
		line-height: 14px;
		margin-top: 12px;
	}
	.slideverify{

		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0,0,0,.4);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 7;
	}
	ol, ul {
		list-style: none;
	}

	.header-nav li.nav-first {
		border-left: 0;
	}

	.header-nav li {
		float: left;
		padding: 0 0 0 15px;
		margin-right: 15px;
		border-left: 1px solid #6c6c6c;
	}

	.header-nav li a {
		color: #6c6c6c;
	}

	h1, h2, h3, h4, h5, h6 {
		font-size: 100%;
		font-weight: 500;
	}
</style>